<xux-input-select
  [field]="field"
  [shouldShowDropdown]="false"
  (selectClick)="selectClickHandler()"
></xux-input-select>
